import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-accent-500 rounded-full"></span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">热度榜单</h2>
        </div>

        <div className="bg-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingData.map((item, index) => (
            <div
              key={item.id}
              className={`flex items-center gap-4 px-5 py-4 transition-colors duration-200 cursor-pointer hover:bg-background-50 ${
                index < rankingData.length - 1 ? 'border-b border-background-200/40' : ''
              }`}
            >
              <div className={`w-8 h-8 flex items-center justify-center rounded-lg font-heading text-sm shrink-0 ${
                index < 3
                  ? 'bg-primary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {index + 1}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm text-foreground-900 truncate">{item.title}</span>
                  {item.tag && (
                    <span className={`inline-block px-1.5 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${
                      item.tag === 'NEW'
                        ? 'bg-accent-100 text-accent-700'
                        : item.tag === '爆'
                        ? 'bg-primary-100 text-primary-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}>
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex items-center gap-3 shrink-0">
                <span className={`text-xs ${
                  item.trend === 'up' ? 'text-accent-500' : 'text-foreground-400'
                }`}>
                  <i className={`${item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} mr-0.5`}></i>
                </span>
                <span className="text-sm font-medium text-foreground-700 whitespace-nowrap">
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}